import { useMutation, useQueryClient } from 'react-query'

import { v1UserQueries } from '@webapp/platform/iam/query-configs/v1UserQueries'
import { type SlackIntegrationError } from '@webapp/platform/integrations/business-logic/errors/SlackIntegrationError'
import { slackIntegrationRepository } from '@webapp/platform/integrations/data-access/repositories/SlackIntegrationRepository'

interface UnlinkUserVariables {
  procurifyUserId: number
}

export const useUnlinkSlackUserModel = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation<
    void,
    SlackIntegrationError,
    UnlinkUserVariables
  >({
    mutationFn: ({ procurifyUserId }: UnlinkUserVariables) => {
      return slackIntegrationRepository.unlinkUser(procurifyUserId)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: v1UserQueries.activeUsers().queryKey,
      })
    },
  })

  return {
    unlinkUser: mutation.mutateAsync,
    isUnlinking: mutation.isLoading,
  }
}
